
export const getters = {
    profile: state => state.userprofile,
    myRole: state => state.usersrole
}
export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/userprofile/getters.js